import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-building-form-editor',
  templateUrl: './building-form-editor.component.html',
  styleUrls: ['./building-form-editor.component.css']
})
export class BuildingFormEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
